/**
 * ソースプロバイダの生成（配信モードの判断は source/delivery.ts）。
 */
import type { SourceProvider } from '../core/source';
import type { DeliveryKind } from './delivery';
import { ImageTilesProvider } from './image-tiles/image-source';
import { PdfSourceProvider } from './pdf/pdf-source';

export interface SourceOptions {
  assetBase: string;
  onError: (error: unknown) => void;
  /** 読み込み進捗（総量が分かる PDF モードだけが呼ぶ）。 */
  onProgress?: (loaded: number, total: number) => void;
  /** Range 取得のチャンク長（バイト・PDF モードのみ意味を持つ）。 */
  rangeChunkSize?: number;
}

export function createSource(kind: DeliveryKind, options: SourceOptions): SourceProvider {
  return kind === 'image'
    ? new ImageTilesProvider()
    : new PdfSourceProvider({
        assetBase: options.assetBase,
        onError: options.onError,
        ...(options.onProgress ? { onProgress: options.onProgress } : {}),
        ...(options.rangeChunkSize ? { rangeChunkSize: options.rangeChunkSize } : {}),
      });
}
